import { bind } from "@react-rxjs/core"
import { createSignal } from "@react-rxjs/utils"
import { curveBasis } from "d3"
import { map, scan, timer } from "rxjs"

import { currencyPairs$ } from "@/services/currencyPairs"
import { getPriceUpdates$ } from "@/services/prices"
import { getDataPoints, toSvgPath, withScales } from "@/utils/historicalChart"

export const WIDTH = 100
export const HEIGHT = 20
const MAX_SECONDS = 60

const [updatesPerSecond$, setUpdatesPerSecond] = createSignal<number>()

const [useUpdatesPerSecond] = bind(updatesPerSecond$, 0)

currencyPairs$.subscribe((currencyPairs) => {
  let count = 0

  Object.keys(currencyPairs).forEach((symbol) => {
    getPriceUpdates$(symbol).subscribe(() => {
      count++
    })
  })

  timer(1000, 1000).subscribe(() => {
    setUpdatesPerSecond(count)
    count = 0
  })
})

export const updatesPerSecondHistory$ = updatesPerSecond$.pipe(
  scan(
    (acc, value) => {
      acc.push(value)
      if (acc.length > MAX_SECONDS) {
        acc.splice(0, 1)
      }
      return [...acc]
    },
    [0],
  ),
)

const [useHistoricalPath] = bind(
  updatesPerSecondHistory$.pipe(
    map((updates) => {
      const dataPoints = getDataPoints<number>((count, idx) => [
        new Date(idx),
        count,
      ])(updates)

      const scales = withScales([0, WIDTH], [0, HEIGHT])(dataPoints)
      return toSvgPath(curveBasis)(scales)
    }),
  ),
)

export { useHistoricalPath, useUpdatesPerSecond }
